
export namespace WishlistToggle {
let getFavoriteProducts = () =>  {
	let productIds: string[] = [];
	if (localStorage.getItem('wishlist-products')) {
		productIds = JSON.parse(localStorage.getItem('wishlist-products'));
	}
	return productIds;
}

let checkOnPageFavorites = ()=>{
	$('.js-save-for-later').each(function() {
		if ($(this).data('modelnumber')) {
			let favoriteProducts = getFavoriteProducts();			
			updateSavedStateProducts(this, favoriteProducts);
		}		
	});
}

let updateSavedStateProducts = (el, favoriteProducts) => {
	let modelNumber = $(el).data('modelnumber').toString();	
	if (favoriteProducts.indexOf(modelNumber) > -1) {
		let $favoriteIcon = $(el).find('.btn-outline-primary');			
		$favoriteIcon.addClass('active');
		let $label = $(el).find('.js-save-for-later-label');
		if ($label.length && $label.data('checked')) {
			$label.text($label.data('checked'));
		}
	}	
}

let addFavorite = (modelNumber) => {
	let productIds = getFavoriteProducts();	
    if(modelNumber != null)
	{
		if (productIds.indexOf(modelNumber) < 0) {
			productIds.push(modelNumber);
		}
		localStorage.setItem('wishlist-products', JSON.stringify(productIds));
    }		
}

let removeFavorite = (modelNumber) => {
	let productIds = getFavoriteProducts();   
	if(modelNumber != null)
	{
		if (productIds.indexOf(modelNumber) > -1) {
			productIds.splice(productIds.indexOf(modelNumber), 1);
		}
		localStorage.setItem('wishlist-products', JSON.stringify(productIds));
    }
}

export const init = () => {
	if (window['favoriteToggleInitialized']) { return; }

	checkOnPageFavorites();

	$(document).on('click', '.js-save-for-later', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let $this = $(this);
		let $favoriteIcon = $this.find('.btn-outline-primary');			
		let $label = $this.find('.js-save-for-later-label');
		let isChecked = $favoriteIcon.hasClass('active');
		let modelNumber = $this.data('modelnumber').toString();		
		$favoriteIcon.toggleClass('active');	

		if (!isChecked) {
			addFavorite(modelNumber);
		} else {
			removeFavorite(modelNumber);
		}

	//	let favoriteProducts = getFavoriteProducts();
	//	updateSavedStateProducts(this, favoriteProducts);		

		if (!isChecked && $label.length && $label.data('checked')) {
			$label.text($label.data('checked'));
		} else if ($label.length && $label.data('unchecked')) {
			$label.text($label.data('unchecked'));
		}
		// This event triggers the Favorites counter in the nav to update
		window.dispatchEvent(new Event('favorites'));
	});

	window['favoriteToggleInitialized'] = true;
}
}



